<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
  
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">邀请收益</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>
      
      <div class="top ub ub-ver ub-pc">
        <div class="sum-score ub ub-pe"><a>￥</a><span id="profit-sum">0</span></div>
            <ul class="ub ub-ac1">
                
                <li class="item ub ub-ver ub-pc ub-ac1">
                <span class="num"><a>￥</a>{{ sum_data.profit_recharge }}</span>
                <span class="score">充值收益</span>
                </li>
    
                <li class="y"></li>
    
                <li class="item ub ub-ver ub-pc ub-ac1">
                <span class="num"><a>￥</a>{{ sum_data.profit_gift }}</span>
                <span class="score">礼物收益</span>
                </li>

                <li class="y"></li>
    
                <li class="item ub ub-ver ub-pc ub-ac1">
                <span class="num"><a>￥</a>{{ sum_data.profit_chat }}</span>
                <span class="score">私信收益</span>
                </li>
            </ul>
        </div>

        <div class="data_block">
            <div class="income-block">
                    <ul class="ub ub-ac1">
                        <li class="income-item ub ub-ver ub-pc ub-ac1">
                            <span class="mny">￥{{ profit.mny_today }}</span>
                            <span class="dtm">今日</span>
                        </li>

                        <li class="y"></li>

                        <li class="income-item ub ub-ver ub-pc ub-ac1">
                            <span class="mny">￥{{ profit.mny_yest }}</span>
                            <span class="dtm">昨日</span>
                        </li>

                        <li class="y"></li>

                        <li class="income-item ub ub-ver ub-pc ub-ac1">
                            <span class="mny">￥{{ profit.mny_30day }}</span>
                            <span class="dtm">近30天</span>
                        </li>
                    </ul>
            </div>
            
        </div>
        
        <div class="menu-block">
                <div class="ub ub-pc menu-item" v-if="arr.length > 0">
                  <span class="width7 ub-f1">时间</span>
                  <span class="width6">头像</span>
                  <span class="width7">昵称</span>
                  <span class="width6">类型</span>
                  <span class="width7">金额/积分</span>
                  <span class="width6">分成</span>
                  <span class="width7">邀请收益</span>
                </div>
                <div class="line"></div>
                <li v-for="(item,index) in arr" :key="index" >
                
                <div class="ub ub-pc ub-ac menu-item">
                    <div class="width7 sp ub ub-ver ub-pc">
                        <span>{{item.date}}</span>
                        <span>{{item.time}}</span>
                    </div>
                    <div class="width6 sp"><img class="photo" v-if="item.photo" :src="item.photo" alt="" /></div>
                    <span class="width7 sp">{{ item.nick.length > 4 ? item.nick.substr(0,4) + '...' : item.nick }}</span>
                    <span class="width6 sp">{{item.type}}</span>
                    <span class="width7 sp">{{item.jine}}</span>
                    <span class="width6 sp">{{ item.fencheng }}</span>
                    <div class="width7 sp">{{ item.profit }}</div>
                </div>
                <div v-if="index < arr.length-1" class="line"></div>
                </li>
            </div>

            <div class="more ub ub-pc ub-ac" v-if="arr.length > 0">
                    <div class="ub ub-ac ub-pc btn" @click="more()"><span>加载更多</span></div>
            </div>

            <div class="no-404 ub ub-pc ub-ac ub-ver" v-if="arr.length <= 0">
              <img src="../../assets/img/new2024/no-friends.png" alt="">
              <span class="tip-404">暂无收益</span>
              <div class="btn-404" @click="back()"><span>继续邀请</span></div>
            </div>
    </div>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../../api/common";
  export default {
    data() {
      return {
        theme_dark: false,
        sum_data: {
            profit_sum: 0,
            profit_recharge: 0,
            profit_gift: 0,
            profit_chat: 0
        },
        profit: {
            mny_today: 0,
            mny_yest: 0,
            mny_30day: 0
        },
        arr: [],
        last_dtm: "",
        size: 10,
      };
    },
    mounted() {
      this.loading("加载中...",5000);
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
      this.init_sumData();
    },
  
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
  
      init_page(){
        
      },
      init_sumData() {
        var invite_sum = this.$store.state.http_cache.invite_sum;
        var dtm = invite_sum.dtm;
        var dtm_now = new Date().getTime();
        var timeDiff = (dtm_now - dtm ) / (1000 * 60); //相差时间
        //使用缓存数据
        if (timeDiff < 10) {
          this.$loading.close();
          if (invite_sum.data_serve.score_total > 0) {
            this.more();
          }
            this.sum_data.profit_sum = (invite_sum.data_serve.score_total / 1000).toFixed(2);
            this.sum_data.profit_recharge = (invite_sum.data_serve.score_pay / 1000).toFixed(2);
            this.sum_data.profit_gift = (invite_sum.data_serve.score_gift / 1000).toFixed(2);
            this.sum_data.profit_chat = (invite_sum.data_serve.score_msg / 1000).toFixed(2);
            tool.roll_add_num(this.sum_data.profit_sum, "profit-sum", "");

            this.profit.mny_today = (invite_sum.data_serve.score_1 / 1000).toFixed(2);
            this.profit.mny_yest = (invite_sum.data_serve.score_2 / 1000).toFixed(2);
            this.profit.mny_30day = (invite_sum.data_serve.score_3 / 1000).toFixed(2);
          return false;
        }

        var uid = this.$store.state.uid;
        var self = this;
        self.get({
          url: "/App/GetInviteSum_Data?uid=" + uid,
          success: function(data) {
            this.$loading.close();
            if (data.score_total > 0) {
              self.more();
            }

            var obj = {
              dtm: new Date().getTime(),
              data_serve: data
            }
            self.$store.commit("set_http_cache", {invite_sum: obj});

            self.sum_data.profit_sum = (data.score_total / 1000).toFixed(2);
            self.sum_data.profit_recharge = (data.score_pay / 1000).toFixed(2);
            self.sum_data.profit_gift = (data.score_gift / 1000).toFixed(2);
            self.sum_data.profit_chat = (data.score_msg / 1000).toFixed(2);
            tool.roll_add_num(self.sum_data.profit_sum, "profit-sum", "");

            self.profit.mny_today = (data.score_1 / 1000).toFixed(2);
            self.profit.mny_yest = (data.score_2 / 1000).toFixed(2);
            self.profit.mny_30day = (data.score_3 / 1000).toFixed(2);
          },
          error: function(res) {}
        });
      },
      more(){
        this.loading("加载中...",5000);
        var uid = this.$store.state.uid;
        var self = this;
        self.get({
        url: "/App/GetInviteList_MnyScore?uid=" + uid + "&size="+self.size+"&time=" + self.last_dtm,
        success: function(data) {
          self.$loading.close();
          if (data.length <= 0 && self.arr.length > 0) {
              self.$toast.center("没有更多数据");
          }
            for (var i = 0; i < data.length; i++) {
                var user = data[i];
                self.last_dtm = user.dtm;
                //初始化数据
                user.photo = self.$store.state.url + "/photo/" + user.photo;
                var dtmParts = user.dtm.split(' ');
                user.date = dtmParts[0].replace(/-/g, ".");
                user.time = dtmParts[1];
                
                user.profit = user.mny * 100;
                if (user.ctype_dtl == "消息收入") {
                  user.type = "私信";
                  user.fencheng = "20%";
                  user.jine = user.mny;
                  user.profit = user.mny * 0.2;
                }
                if (user.ctype_dtl == "收到礼物") {
                  user.type = "礼物";
                  user.fencheng = "10%";
                  user.jine = user.mny;
                  user.profit = user.mny * 0.1;
                }
                if (user.ctype == "充值") {
                  user.type = "充值";
                  user.fencheng = "10%";
                  user.jine = "￥" + user.mny;
                  user.profit = user.mny * 100;
                }
                user.profit = Math.floor(user.profit);
            }
            self.arr = self.arr.concat(data);
        },
        error: function(res) {}
        });
      },

      loading(title,time) {
        var self = this;
          this.$loading(title);
          setTimeout(() => {
              self.$loading.close();
          }, time);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background: linear-gradient(to bottom, #FE9CC0, #fff);
    background-size: 100% 100%;
    .nav-top {
      background-color: #8A61FF;
    }
    .nav-right {
      padding-right: 0.5rem;
      .nav-lable {
        margin: 0;
        font-size: 0.9rem;
        color: #fff;
      }
    }
  
    .top {
      padding: 1rem 0.8rem;
      background-color: #8A61FF;
      background-image: linear-gradient(to bottom, #8A61FF, #FE9CC0);
      .sum-score {
        span {
          font-size: 1.7rem;
          font-weight: bold;
          color: #FFF;
        }
        a {
          margin-left: 0.1rem;
          font-size: 0.9rem;
          color: #FFF;
          line-height: 1.6rem;
        }
      }
      ul {
        margin-top: 1rem;
        width: 100%;
      }
      .item {
        .num {
          font-size: 1.2rem;
          color: #f7f2f2;
          a {
            margin-left: 0.1rem;
            font-size: 0.75rem;
            color: #FFF;
            line-height: 1.3rem;
            }
        }
        .score {
          margin-top: 0.3rem;
          font-size: 0.6rem;
          color: #f3bfe8;
        }
      }
    }

    .data_block {
        padding: 0.5rem 0.8rem;
        background: linear-gradient(to bottom, #FE9CC0, #fff 40rem);
    }

    .income-block {
        background-color: #fff;
            padding: 0.5rem 0.8rem;
            border-radius: 0.5rem;
            .icon {
            padding: 0 0.3rem 0.5rem 0;
            width: 1.4rem;
            height: 1.4rem;
            }
            .y {
            border: 0.8px solid #f1f1f1;
            margin-top: 0.5rem;
            height: 4rem;
            }
            .income-item {
            width: 5rem;
            height: 4.5rem;
            .mny {
                font-weight: 600;
                font-size: 1.2rem;
                color: rgb(186, 97, 255);
            }
            .dtm {
                color: #999;
                font-size: 0.85rem;
            }
            }
    }

    .menu-block {
        overflow-x: auto;
        white-space: nowrap;
        padding: 0 0.3rem;
        background-color: #fff;
        .menu-item {
        height: 3rem;
        justify-content: space-between;
            .width6 {
                width: 6rem;
                font-size: 0.75rem;
            }
            .width7 {
                width: 7rem;
                font-size: 0.75rem;
            }
            .photo {
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
            }
            .sp {
              color: #666;
            }
        }
    }
    .more {
      background-color: #fff;
      padding-top: 0.5rem;
      padding-bottom: 1rem;
    }
  }

  .line {
    border-bottom: 1px solid #d3d3d3;
  }

  .btn {
      margin-top: 0.5rem;
      span {
        font-size: 0.75rem;
        color: #333;
      }
  }

  .no-404 {
    margin-top: 10rem;
    background-size: 100% 100%;
    .tip-404 {
      margin-top: 1rem;
      font-size: 0.75rem;
    }
    .btn-404 {
      margin-top: 1rem;
      padding: 0.5rem 1rem;
      border-radius: 1rem;
      background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
      span {
        font-size: 0.9rem;
        color: #FFFFFF;
      }
    }
  }
  
  
  .container-dark {
    min-height: 100vh;
    background: linear-gradient(to bottom, #5f3b48, #2F2E33);
    .nav-top {
      background-color: #3c296e;
    }
    .top {
      background-image: linear-gradient(to bottom, #3c296e, #5f3b48);
      .item {
        .num {
          color: #e5e5e5;
        }
        .score {
          color: #808080;
        }
      }
    }
    .data_block {
      background: #5f3b48;
      .income-block {
        background-color: #2c2b30;
        .y {
            border: 0.8px solid #404040;
            }
      }
    }
    .menu-block {
      background-color: #2c2b30;
      .menu-item {
        span {
          color: #FDFDFD;
        }
      }
    }
    .more {
      background-color: #2c2b30;
      .btn {
        span {
          color: #FDFDFD;
        }
      }
      
    }
    .line {
      border-bottom: 1px solid #404040;
    }

    .no-404 {
      .tip-404 {
        color: #FDFDFD;
      }
    }
  }
  
  </style>
  